import { ContentLayout } from '@metorial/layout';
import { Outlet } from 'react-router-dom';
import { DashboardShell } from '../../../shell';

// Account area (cloud-spec §8) inside the BlackOS shell: Profile · Portals.
export let AccountPageLayout = () => (
  <DashboardShell>
    <ContentLayout variant="medium2">
      <Outlet />
    </ContentLayout>
  </DashboardShell>
);
